import { combineReducers } from 'redux';
import page from '../../components/page/reducer'
import header from '../../components/header/reducer'
import profile from '../../components/user/setting/reducer'
export default combineReducers({
    page: page,
    header: header,
    profile: profile,
})


// WEBPACK FOOTER //
// ./src/redux/reducer/reducers.js